import { Component, OnInit } from '@angular/core';

import { Breadcrumb } from './breadcrumb.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { Project } from '../projects/project.model';
import { Campaign } from '../campaigns/campaign.model';
import { SharedDataService } from '../shared/data.service';

declare var $: any;

@Component({
  selector: 'wm-service-block-breadcrumb',
  template: require('./breadcrumb.component.html'),
})

export class ServiceBlockBreacrumbComponent implements OnInit {
  breadcrumb: Breadcrumb;
  route_name: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private shared: SharedDataService
  ) {
    this.breadcrumb = {campaign: <Campaign>{}, project: <Project>{}};
  }

  setCampaign() {
    this.shared.getCampaign().subscribe(campaign => {
      if (!!campaign) {
        this.breadcrumb.campaign = campaign;
      }
    });
  }

  setProject() {
    this.shared.getProject().subscribe(project => {
      if (!!project) {
        this.breadcrumb.project = project;
      }
    });
  }

  checkProject(snapshot) {
    $('.breadcrumb-block').removeClass('breadcrumb-block--all');

    switch (snapshot.data.tab_name) {
      case 'projects':
        this.breadcrumb.campaign = <Campaign>{};
        if (!!snapshot.params['id']) {
          this.setProject();
        } else {
          $('.breadcrumb-block').addClass('breadcrumb-block--all');
          this.breadcrumb.project.name = 'Все проекты';
          this.breadcrumb.project.id = '';
        }
        break;
      case 'campaigns':
        this.setProject();
        if (!!snapshot.params['id']) {
          this.setCampaign();
        } else {
          this.shared.getProject().subscribe(project => {
            if (!!project) {
              this.breadcrumb.campaign.name = 'Все кампании';
              this.breadcrumb.campaign.id = '';
            }
          });
        }
        break;
      case 'links':
      case 'counters':
        this.setProject();
        this.setCampaign();
        break;
      default:
        this.breadcrumb = {campaign: <Campaign>{}, project: <Project>{}};
        break;
    }
  }

  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(event => {
        let currentRoute = this.route.root;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
        }

        this.checkProject(currentRoute.snapshot);
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/service-block/breadcrumb.component.ts